module.exports = __webpack_public_path__ + "img/744.28f5e4a5.jpg";